import { CvpLocale } from "../WSUtils/getIdLanguage";
import { LocContext } from "./LocContext";

export async function getTranslationMap(
  stringContext: LocContext,
  locale: CvpLocale
): Promise<{ [key: string]: string }> {
  if (stringContext === LocContext.ADMIN) {
    if (locale === CvpLocale.da) {
      return (await import("../localization/translated/da/admin")).default;
    }
    if (locale === CvpLocale["sv-SE"]) {
      return (await import("../localization/translated/sv/admin")).default;
    }
    if (locale === CvpLocale.pl) {
      return (await import("../localization/translated/pl/admin")).default;
    }
    if (locale === CvpLocale.de) {
      return (await import("../localization/translated/de/admin")).default;
    }
    if (locale === CvpLocale.so) {
      return (await import("../localization/translated/so/admin")).default;
    }
    if (locale === CvpLocale["pt-PT"]) {
      return (await import("../localization/translated/pt/admin")).default;
    }
    if (locale === CvpLocale.lt) {
      return (await import("../localization/translated/lt/admin")).default;
    }
    if (locale === CvpLocale.lv) {
      return (await import("../localization/translated/lv/admin")).default;
    }
    if (locale === CvpLocale.sl) {
      return (await import("../localization/translated/sl/admin")).default;
    }
    if (locale === CvpLocale.sk) {
      return (await import("../localization/translated/sk/admin")).default;
    }
    if (locale === CvpLocale.nl) {
      return (await import("../localization/translated/nl/admin")).default;
    }
    if (locale === CvpLocale.fr) {
      return (await import("../localization/translated/fr/admin")).default;
    }
    if (locale === CvpLocale.it) {
      return (await import("../localization/translated/it/admin")).default;
    }
    if (locale === CvpLocale.en) {
      return (await import("../localization/translated/en/admin")).default;
    }
  }

  if (stringContext === LocContext.CV) {
    if (locale === CvpLocale.da) {
      return (await import("../localization/translated/da/cv")).default;
    }
    if (locale === CvpLocale["sv-SE"]) {
      return (await import("../localization/translated/sv/cv")).default;
    }
    if (locale === CvpLocale.pl) {
      return (await import("../localization/translated/pl/cv")).default;
    }
    if (locale === CvpLocale.de) {
      return (await import("../localization/translated/de/cv")).default;
    }
    if (locale === CvpLocale.so) {
      return (await import("../localization/translated/so/cv")).default;
    }
    if (locale === CvpLocale["pt-PT"]) {
      return (await import("../localization/translated/pt/cv")).default;
    }
    if (locale === CvpLocale.lt) {
      return (await import("../localization/translated/lt/cv")).default;
    }
    if (locale === CvpLocale.lv) {
      return (await import("../localization/translated/lv/cv")).default;
    }
    if (locale === CvpLocale.sl) {
      return (await import("../localization/translated/sl/cv")).default;
    }
    if (locale === CvpLocale.sk) {
      return (await import("../localization/translated/sk/cv")).default;
    }
    if (locale === CvpLocale.nl) {
      return (await import("../localization/translated/nl/cv")).default;
    }
    if (locale === CvpLocale.fr) {
      return (await import("../localization/translated/fr/cv")).default;
    }
    if (locale === CvpLocale.it) {
      return (await import("../localization/translated/it/cv")).default;
    }
    if (locale === CvpLocale.en) {
      return (await import("../localization/translated/en/cv")).default;
    }
  }

  if (stringContext === LocContext.GENERAL) {
    if (locale === CvpLocale.da) {
      return (await import("../localization/translated/da/general")).default;
    }
    if (locale === CvpLocale["sv-SE"]) {
      return (await import("../localization/translated/sv/general")).default;
    }
    if (locale === CvpLocale.pl) {
      return (await import("../localization/translated/pl/general")).default;
    }
    if (locale === CvpLocale.de) {
      return (await import("../localization/translated/de/general")).default;
    }
    if (locale === CvpLocale.so) {
      return (await import("../localization/translated/so/general")).default;
    }
    if (locale === CvpLocale["pt-PT"]) {
      return (await import("../localization/translated/pt/general")).default;
    }
    if (locale === CvpLocale.lt) {
      return (await import("../localization/translated/lt/general")).default;
    }
    if (locale === CvpLocale.lv) {
      return (await import("../localization/translated/lv/general")).default;
    }
    if (locale === CvpLocale.sl) {
      return (await import("../localization/translated/sl/general")).default;
    }
    if (locale === CvpLocale.sk) {
      return (await import("../localization/translated/sk/general")).default;
    }
    if (locale === CvpLocale.nl) {
      return (await import("../localization/translated/nl/general")).default;
    }
    if (locale === CvpLocale.fr) {
      return (await import("../localization/translated/fr/general")).default;
    }
    if (locale === CvpLocale.it) {
      return (await import("../localization/translated/it/general")).default;
    }
    if (locale === CvpLocale.en) {
      return (await import("../localization/translated/en/general")).default;
    }
  }

  if (stringContext === LocContext.JOB) {
    if (locale === CvpLocale.da) {
      return (await import("../localization/translated/da/job")).default;
    }
    if (locale === CvpLocale["sv-SE"]) {
      return (await import("../localization/translated/sv/job")).default;
    }
    if (locale === CvpLocale.pl) {
      return (await import("../localization/translated/pl/job")).default;
    }
    if (locale === CvpLocale.de) {
      return (await import("../localization/translated/de/job")).default;
    }
    if (locale === CvpLocale.so) {
      return (await import("../localization/translated/so/job")).default;
    }
    if (locale === CvpLocale["pt-PT"]) {
      return (await import("../localization/translated/pt/job")).default;
    }
    if (locale === CvpLocale.lt) {
      return (await import("../localization/translated/lt/job")).default;
    }
    if (locale === CvpLocale.lv) {
      return (await import("../localization/translated/lv/job")).default;
    }
    if (locale === CvpLocale.sl) {
      return (await import("../localization/translated/sl/job")).default;
    }
    if (locale === CvpLocale.sk) {
      return (await import("../localization/translated/sk/job")).default;
    }
    if (locale === CvpLocale.nl) {
      return (await import("../localization/translated/nl/job")).default;
    }
    if (locale === CvpLocale.fr) {
      return (await import("../localization/translated/fr/job")).default;
    }
    if (locale === CvpLocale.it) {
      return (await import("../localization/translated/it/job")).default;
    }
    if (locale === CvpLocale.en) {
      return (await import("../localization/translated/en/job")).default;
    }
  }

  if (stringContext === LocContext.JOBS) {
    if (locale === CvpLocale.da) {
      return (await import("../localization/translated/da/jobs")).default;
    }
    if (locale === CvpLocale["sv-SE"]) {
      return (await import("../localization/translated/sv/jobs")).default;
    }
    if (locale === CvpLocale.pl) {
      return (await import("../localization/translated/pl/jobs")).default;
    }
    if (locale === CvpLocale.de) {
      return (await import("../localization/translated/de/jobs")).default;
    }
    if (locale === CvpLocale.so) {
      return (await import("../localization/translated/so/jobs")).default;
    }
    if (locale === CvpLocale["pt-PT"]) {
      return (await import("../localization/translated/pt/jobs")).default;
    }
    if (locale === CvpLocale.lt) {
      return (await import("../localization/translated/lt/jobs")).default;
    }
    if (locale === CvpLocale.lv) {
      return (await import("../localization/translated/lv/jobs")).default;
    }
    if (locale === CvpLocale.sl) {
      return (await import("../localization/translated/sl/jobs")).default;
    }
    if (locale === CvpLocale.sk) {
      return (await import("../localization/translated/sk/jobs")).default;
    }
    if (locale === CvpLocale.nl) {
      return (await import("../localization/translated/nl/jobs")).default;
    }
    if (locale === CvpLocale.fr) {
      return (await import("../localization/translated/fr/jobs")).default;
    }
    if (locale === CvpLocale.it) {
      return (await import("../localization/translated/it/jobs")).default;
    }
    if (locale === CvpLocale.en) {
      return (await import("../localization/translated/en/jobs")).default;
    }
  }

  if (stringContext === LocContext.PROFILE) {
    if (locale === CvpLocale.da) {
      return (await import("../localization/translated/da/profile")).default;
    }
    if (locale === CvpLocale["sv-SE"]) {
      return (await import("../localization/translated/sv/profile")).default;
    }
    if (locale === CvpLocale.pl) {
      return (await import("../localization/translated/pl/profile")).default;
    }
    if (locale === CvpLocale.de) {
      return (await import("../localization/translated/de/profile")).default;
    }
    if (locale === CvpLocale.so) {
      return (await import("../localization/translated/so/profile")).default;
    }
    if (locale === CvpLocale["pt-PT"]) {
      return (await import("../localization/translated/pt/profile")).default;
    }
    if (locale === CvpLocale.lt) {
      return (await import("../localization/translated/lt/profile")).default;
    }
    if (locale === CvpLocale.lv) {
      return (await import("../localization/translated/lv/profile")).default;
    }
    if (locale === CvpLocale.sl) {
      return (await import("../localization/translated/sl/profile")).default;
    }
    if (locale === CvpLocale.sk) {
      return (await import("../localization/translated/sk/profile")).default;
    }
    if (locale === CvpLocale.nl) {
      return (await import("../localization/translated/nl/profile")).default;
    }
    if (locale === CvpLocale.fr) {
      return (await import("../localization/translated/fr/profile")).default;
    }
    if (locale === CvpLocale.it) {
      return (await import("../localization/translated/it/profile")).default;
    }
    if (locale === CvpLocale.en) {
      return (await import("../localization/translated/en/profile")).default;
    }
  }

  if (stringContext === LocContext.WORKSCHEDULE) {
    if (locale === CvpLocale.da) {
      return (await import("../localization/translated/da/workSchedule"))
        .default;
    }
    if (locale === CvpLocale["sv-SE"]) {
      return (await import("../localization/translated/sv/workSchedule"))
        .default;
    }
    if (locale === CvpLocale.pl) {
      return (await import("../localization/translated/pl/workSchedule"))
        .default;
    }
    if (locale === CvpLocale.de) {
      return (await import("../localization/translated/de/workSchedule"))
        .default;
    }
    if (locale === CvpLocale.so) {
      return (await import("../localization/translated/so/workSchedule"))
        .default;
    }
    if (locale === CvpLocale["pt-PT"]) {
      return (await import("../localization/translated/pt/workSchedule"))
        .default;
    }
    if (locale === CvpLocale.lt) {
      return (await import("../localization/translated/lt/workSchedule"))
        .default;
    }
    if (locale === CvpLocale.lv) {
      return (await import("../localization/translated/lv/workSchedule"))
        .default;
    }
    if (locale === CvpLocale.sl) {
      return (await import("../localization/translated/sl/workSchedule"))
        .default;
    }
    if (locale === CvpLocale.sk) {
      return (await import("../localization/translated/sk/workSchedule"))
        .default;
    }
    if (locale === CvpLocale.nl) {
      return (await import("../localization/translated/nl/workSchedule"))
        .default;
    }
    if (locale === CvpLocale.fr) {
      return (await import("../localization/translated/fr/workSchedule"))
        .default;
    }
    if (locale === CvpLocale.it) {
      return (await import("../localization/translated/it/workSchedule"))
        .default;
    }
    if (locale === CvpLocale.en) {
      return (await import("../localization/translated/en/workSchedule"))
        .default;
    }
  }

  throw new Error(
    `No translations for context/locale: ${stringContext}/${locale}`
  );
}
